import TraditionalComparison from "@/components/comparisonWithTraditional";
import { COMPARISON_CONSTANTS_NETWORKING } from "./constants";

const ComparisonComp = () => {
  return <TraditionalComparison {...COMPARISON_CONSTANTS_NETWORKING} />;
};

export default ComparisonComp;
